module.exports = __webpack_public_path__ + "static/scholle_mini-464a3dd46c246fe146bd3f42e5a969d2.png";